import { Tabs } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ManageUsers from 'Admin/ManageUsers';
import { tracking } from '../../App/Tracking';

const Admin = () => {
  const { t: translate } = useTranslation('admin');

  return (
    <Tabs
      className="admin-page sass-migrated"
      tabs={[
        {
          id: 'manage_users',
          text: 'Manage Users',
          content: <ManageUsers />,
          onClick: () =>
            tracking.track(`admin-dashboard-tab-clicked`, {
              adminTabName: 'admin',
            }),
        },
      ]}
      children={<h1 className="primary-title">{translate('title')}</h1>}
    />
  );
};

export default Admin;
